import React from "react";

function InfoIcon(props) {
  return (
    <span>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}>
        <path
          d="M7.99992 1.33301C4.32592 1.33301 1.33325 4.32567 1.33325 7.99967C1.33325 11.6737 4.32592 14.6663 7.99992 14.6663C11.6739 14.6663 14.6666 11.6737 14.6666 7.99967C14.6666 4.32567 11.6739 1.33301 7.99992 1.33301ZM7.99992 2.66634C10.9533 2.66634 13.3333 5.04626 13.3333 7.99967C13.3333 10.9531 10.9533 13.333 7.99992 13.333C5.0465 13.333 2.66659 10.9531 2.66659 7.99967C2.66659 5.04626 5.0465 2.66634 7.99992 2.66634ZM7.33325 4.66634V5.99967H8.66659V4.66634H7.33325ZM7.33325 7.33301V11.333H8.66659V7.33301H7.33325Z"
          fill="currentColor"
        />
      </svg>
    </span>
  );
}

export default InfoIcon;
